import React from 'react';
import { dynastyTheme } from '../../services/colorService';

const PlayByPlay = ({ plays }) => {
  if (!plays || plays.length === 0) {
    return (
      <div className={`p-6 text-center ${dynastyTheme.classes.text.neutralLight}`}>
        No plays yet
      </div>
    );
  }

  // Group plays by inning/half for section headers
  let lastInningKey = '';

  return (
    <div className="max-h-[600px] overflow-y-auto">
      {plays.map((play, idx) => {
        const inningKey = `${play.half_inning}-${play.inning}`;
        const showHeader = inningKey !== lastInningKey;
        lastInningKey = inningKey;

        const half = play.half_inning === 'top' ? 'Top' : 'Bot';
        const isOwned = play.ownership?.batter_team || play.ownership?.pitcher_team;

        return (
          <React.Fragment key={idx}>
            {showHeader && (
              <div className={`sticky top-0 z-10 px-3 py-1.5 ${dynastyTheme.classes.bg.darkLighter} border-b ${dynastyTheme.classes.border.neutral}`}>
                <span className={`text-xs font-bold ${dynastyTheme.classes.text.primary}`}>
                  {half} {play.inning}
                </span>
              </div>
            )}
            <div
              className={`px-3 py-2 border-b ${dynastyTheme.classes.border.neutral}`}
              style={{ backgroundColor: isOwned ? dynastyTheme.tokens.colors.primaryLight : 'transparent' }}
            >
              <div className="flex items-start gap-2">
                <span className={`text-[10px] min-w-[40px] pt-0.5 ${dynastyTheme.classes.text.neutralLight}`}>
                  {play.outs} out{play.outs !== 1 ? 's' : ''}
                </span>
                <div className="flex-1">
                  <p className={`text-xs ${dynastyTheme.classes.text.white}`}>
                    {play.description}
                  </p>
                  {play.hit_data && (
                    <p className={`text-[10px] mt-0.5 ${dynastyTheme.classes.text.neutralLight}`}>
                      {play.hit_data.exit_velocity && `${play.hit_data.exit_velocity} mph EV`}
                      {play.hit_data.distance && ` \u00B7 ${play.hit_data.distance} ft`}
                      {play.hit_data.launch_angle != null && ` \u00B7 ${play.hit_data.launch_angle}\u00B0 LA`}
                    </p>
                  )}
                  {isOwned && (
                    <div className="flex gap-1 mt-1">
                      {play.ownership.batter_team && (
                        <span className={`text-[9px] px-1.5 py-0.5 rounded font-semibold ${dynastyTheme.classes.bg.primary} ${dynastyTheme.classes.text.dark}`}>
                          {play.ownership.batter_team}
                        </span>
                      )}
                      {play.ownership.pitcher_team && play.ownership.pitcher_team !== play.ownership.batter_team && (
                        <span className={`text-[9px] px-1.5 py-0.5 rounded font-semibold bg-neutral-600 ${dynastyTheme.classes.text.white}`}>
                          vs {play.ownership.pitcher_team}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default PlayByPlay;
